import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col min-h-screen h-full bg-gray-100 p-2" }
const _hoisted_2 = { class: "h-[calc(100vh-101px)] max-h-[calc(100%-101px)] mb-[85px]" }

import { ref, onMounted, provide } from 'vue';
  import Footer from '@/components/Footer.vue';
  import AuthLayout from '@/layout/AuthLayout.vue';
  import { Notifications } from '@kyvg/vue3-notification';
  import { getSession } from '@/indexedDB';
  import { DB } from '@/types';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  const db = ref<DB | null>(null);
  const isReady = ref(false);
  provide('DB', db.value);

  onMounted(async () => {
    console.log('deployed');
    db.value = await getSession('user');
    isReady.value = true;
  });

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (isReady.value)
    ? (_openBlock(), _createBlock(AuthLayout, { key: 0 }, {
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("main", _hoisted_2, [
              _createVNode(_unref(Notifications), { position: "top right" }),
              (isReady.value)
                ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
                : _createCommentVNode("", true)
            ]),
            (isReady.value)
              ? (_openBlock(), _createBlock(Footer, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})